import Search from "view3/Search.js";

import connectFunction from "redux/connectFunction";

function mapStateToProps(state) {
  return {
    categories: state.categories,
    alert: state.alert,
    city: state.city,
    attributes: state.attributes
  };
}

const SearchContainer = connectFunction(mapStateToProps)(Search);
export default SearchContainer;
